import React from 'react'
import { Tabs } from 'antd'
import {
	AppstoreOutlined,
	CheckCircleOutlined,
	CloseCircleOutlined,
	DeleteOutlined,
	FolderOpenOutlined,
	RiseOutlined,
	BarChartOutlined
} from '@ant-design/icons'
import { useTranslation } from 'react-i18next'

import PriceOffers from './PriceOffers'
import StatisticsDashboard from './components/StatisticsDashboard'
import { PRICE_OFFER_STATUS, translatePriceOfferStatusToSk } from '../../utils/enums'

const STATUS_TAB_ICONS: Record<string, React.ReactNode> = {
	all: <AppstoreOutlined />,
	[PRICE_OFFER_STATUS.NOT_ACCEPTED]: <FolderOpenOutlined />,
	[PRICE_OFFER_STATUS.FINISHED]: <CheckCircleOutlined />,
	[PRICE_OFFER_STATUS.DECLINED]: <CloseCircleOutlined />,
	[PRICE_OFFER_STATUS.PRICE_INCREASE]: <RiseOutlined />,
	[PRICE_OFFER_STATUS.PRICE_INCREASE_FINISHED]: <CheckCircleOutlined />,
	[PRICE_OFFER_STATUS.PRICE_INCREASE_DECLINED]: <CloseCircleOutlined />
}

const STATUS_TABS: { key: string; status?: PRICE_OFFER_STATUS }[] = [
	{ key: 'all' },
	{ key: PRICE_OFFER_STATUS.NOT_ACCEPTED, status: PRICE_OFFER_STATUS.NOT_ACCEPTED },
	{ key: PRICE_OFFER_STATUS.FINISHED, status: PRICE_OFFER_STATUS.FINISHED },
	{ key: PRICE_OFFER_STATUS.DECLINED, status: PRICE_OFFER_STATUS.DECLINED },
	{ key: PRICE_OFFER_STATUS.PRICE_INCREASE, status: PRICE_OFFER_STATUS.PRICE_INCREASE },
	{ key: PRICE_OFFER_STATUS.PRICE_INCREASE_FINISHED, status: PRICE_OFFER_STATUS.PRICE_INCREASE_FINISHED },
	{ key: PRICE_OFFER_STATUS.PRICE_INCREASE_DECLINED, status: PRICE_OFFER_STATUS.PRICE_INCREASE_DECLINED }
]

const TabLabel = ({ icon, label }: { icon: React.ReactNode; label: string }) => (
	<span style={{ display: 'inline-flex', alignItems: 'center', gap: 2 }}>
		{icon}
		{label}
	</span>
)

const PriceOffersTabs = () => {
	const { t } = useTranslation('pages')

	return <Tabs defaultActiveKey="1" size={'large'}>
		<Tabs.TabPane tab={t('pages:Zoznam')} key="1">
			<Tabs defaultActiveKey="all" size={'small'} style={{ marginTop: -8 }}>
				{STATUS_TABS.map(({ key, status }) => (
					<Tabs.TabPane
						tab={
							<TabLabel
								icon={STATUS_TAB_ICONS[key]}
								label={status ? translatePriceOfferStatusToSk(status) : t('pages:Všetky')}
							/>
						}
						key={key}
					>
						<PriceOffers
							statusFilter={status ? [status] : undefined}
							queryParamPrefix={key}
						/>
					</Tabs.TabPane>
				))}
				<Tabs.TabPane
					tab={<TabLabel icon={<DeleteOutlined style={{ color: '#ff4d4f' }} />} label={t('pages:Zmazané')} />}
					key="deleted"
				>
					<PriceOffers deleted queryParamPrefix="deleted" />
				</Tabs.TabPane>
			</Tabs>
		</Tabs.TabPane>
		<Tabs.TabPane
			tab={<TabLabel icon={<BarChartOutlined />} label={t('pages:Štatistiky')} />}
			key="2"
		>
			<StatisticsDashboard />
		</Tabs.TabPane>
	</Tabs>
}

export default PriceOffersTabs
